export default {
    Email: 'البريد الإلكتروني',
    ConfirmEmail: 'تأكيد البريد الإلكتروني',
    Password: 'كلمة السر',
    Verificationcode: 'رمز التحقق',
    AlreadyhaveaHitPawaccountLogin: 'هل تمتلك حسابًا على HitPaw؟ تسجيل الدخول',
    ByproceedingyouagreetoourServicesofUseandPrivacyPolicy1:
        'باشتراكك فإنك توافق على خدمات الاستخدام وسياسة الخصوصية',
    ByproceedingyouagreetoourServicesofUseandPrivacyPolicy2:
        'بتسجيل الدخول، فإنك توافق على خدمات الاستخدام وسياسة الخصوصية',
    Byproceedingyouagreetoour: 'باشتراكك فإنك توافق على ',
    ServicesofUse: 'خدمات الاستخدام',
    and: 'و',
    PrivacyPolicy: 'سياسة الخصوصية',
    last: '',
    TheEmailformatisincorrect: 'صيغة البريد الإلكتروني غير صحيحة',
    Pleaseenterthesameemailinbothfields: 'يرجى إدخال نفس البريد الإلكتروني في كلا الخانتين.',
    Thepasswordmustbe850charactersandcontainatleasttwocategoriesamongthefollowingnumberletterorspecialcharacter:
        'يجب أن تتكون كلمة السر من 8 – 50 حرفًا وتحتوي على فئتين على الأقل من الآتي: رقم، حرف أو حرف خاص.',
    Incorrectverificationcode: 'رمز التحقق غير صحيح',
    ThisEmailhasbeenregisteredpleasechooseanother:
        'هذا البريد الإلكتروني مسجل، يرجى استخدام بريد آخر.',
    Cannotbeemptyhere: 'لا يمكن أن يكون هذا فارغًا',
    Rememberme: 'تذكرني',
    ForgotPassword1: 'هل نسيت كلمة السر؟',
    NotaregistereduseryetSignUp: 'هل أنت مستخدم غير مسجل بعد؟ إنشاء حساب',
    Notaregistereduseryet1: 'هل أنت مستخدم غير مسجل بعد؟ ',
    Notaregistereduseryet2: ' إنشاء حساب',
    NoaccountfoundwiththatEmailaddress: 'لم يتم العثور على حساب بهذا البريد الإلكتروني',
    YourEmailaddressorpasswordwasincorrectPleasetryagain:
        'بريدك الإلكتروني أو كلمة سرك غير صحيحة. يرجى المحاولة مجددًا.',
    ForgotPassword2: 'نسيت كلمة السر',
    GetVerificationCode: 'احصل على رمز التحقق',
    VerifyEmail: 'تأكيد البريد الإلكتروني',
    Ithasbeensenttoyourmailboxpleasecheckit:
        'تم إرساله إلى صندوق بريدك الإلكتروني، يرجى التحقق من ذلك',
    PleaseinputEmailaddress: 'يرجى إدخال عنوان البريد الإلكتروني',
    TheEmailisnotregistered: 'البريد الإلكتروني غير مسجل',
    Invalidverificationcodepleasereenterthecorrectone:
        'رمز التحقق غير صالح، يرجى إعادة إدخال رمز صحيح',
    Resetpassword: 'إعادة تعيين كلمة السر',
    Emailaddressverificationsucceeded: 'نجح التحقق من عنوان البريد الإلكتروني',
    Pleaseresetyourpassword: 'يرجى إعادة تعيين كلمة سرك',
    Enteranewpassword: 'أدخل كلمة سر جديدة',
    Confirm: 'تأكيد',
    Newpasswordshouldbe850characterslongcomposedoflettersornumbersoramixtureoflettersnumbers:
        'يجب أن تتكون كلمة السر الجديدة من 8 – 50 حرفًا، سواءً كانوا أرقامًا أو حروفًا أو مزيج من الاثنين',
    Passwordresetsuccessfully: 'تمت إعادة تعيين كلمة السر بنجاح',
    Name: 'الاسم',
    GetCode: 'احصل على رمز',
    Loginsuccessful: 'تسجيل الدخول بنجاح',
    Loginfailed: 'فشل تسجيل الدخول',
    Signupsuccessful: 'نجاح التسجيل',
    Signupfailed: 'فشل التسجيل',
    Getpassword: 'احصل على كلمة السر',
    Authorizationhasexpiredpleaseloginagain:
        'انتهت صلاحية التفويض، يرجى تسجيل الدخول مرة أخرى.',
    Sorrysomethingwentwrongpleasetryagainlater:
        'عذراً، قد حدث خطأ ما. يرجى إعادة المحاولة لاحقاً.',
    Toomanysamerequestsweremadeinashortperiodoftimepleasetryagainlater:
        'تم إرسال عدد كبير من الطلبات نفسها في فترة زمنية قصيرة، يرجى المحاولة مرة أخرى لاحقًا.',
    Couldntfindyouraccountorthepasswordisincorrect:
        'تعذّر العثور على حسابك أو كلمة السر غير صحيحة.',
    Youaretryingtoaccessapaidfunctionpleasesubscribefirst:
        'أنت تحاول الوصول إلى المزية المدفوعة، يرجى الاشتراك أولاً.',
    Accessdeniedfortheunauthorizedrequest: 'تم رفض الوصول للطلب غير المصرح به.',
    Alreadyhaveaccount: 'هل لديك حساب ؟',
    SignUpwithemail: 'استخدام البريد الإلكتروني للتسجيل',
    Securityverification: 'التحقق من الأمن',
    Pleaseenterthecorrectemailaddress: "الرجاء إدخال عنوان البريد الإلكتروني الصحيح !",
    PleaseInputverificationCode: 'الرجاء إدخال رمز التحقق !',
    Pleaseenterthesamepasswordinbothfields: 'الرجاء إدخال نفس كلمة السر في كل المجالات !',
    or: 'أو .',
    ThenewpasswordyouenteredisthesameasyouroldpasswordEnteradifferentpassword:
        'كلمة السر الجديدة التي أدخلتها هي نفس كلمة سرك القديمة. أدخل كلمة سر مختلفة.',
    YourpasswordwasincorrectPleasetryagain: 'كلمة سرك غير صحيحة. يرجى المحاولة مرة أخرى.',
    reg400: 'عذراً، قد حدث خطأ ما. يرجى إعادة المحاولة لاحقاً.',
    reg400223: "البريد الإلكتروني ورمز التحقق غير متطابقين ، يرجى التحقق",
    reg400224: "انتهت صلاحية رمز التحقق",
    500: 'خطأ في الخادم !',
    Afewsecondsaway: 'على بعد ثوان قليلة',
    ContinuewithGoogle: 'تواصل مع جوجل',
    ContinuewithEmail: 'تواصل مع البريد الإلكتروني',
    LoginwithEmail: 'تسجيل الدخول باستخدام البريد الإلكتروني',
    Usemorethan8charactersandmixlettersnumbersandsymbols:
        'استخدم أكثر من 8 أحرف مع مزيج من الأحرف والأرقام والرموز (الرموز الداعمة: @$!%*#_~?&^)',
    ConfirmPassword: 'تأكيد كلمة المرور',
    Pleaseloginwithemail: 'الرجاء تسجيل الدخول باستخدام البريد الإلكتروني',
    youraccount: 'حسابك',
    alreadyexiststoensurethesecuritypleaseverifyitfirst:
        ' موجود بالفعل ، لضمان أمان حسابك ، يرجى إكمال التحقق أولاً.',
    Login: 'تسجيل الدخول',
    exceed6Times: 'انتهت الفترة التجريبية الخاصة بك اليوم ، يرجى الترقية إلى الإصدار Pro للوصول إلى جميع الميزات المتميزة.',
    exceed20M: 'لا يمكن أن يتجاوز حجم الملف للحسابات المجانية 20 ميجابايت ، يرجى الترقية إلى Pro للوصول إلى جميع الميزات المتميزة.'
}